const SELECTOR_STICKY_FORM = '.o-sticky-form-wrapper';

window.addEventListener('scroll', function() {
  var stickyForm = document.querySelector<HTMLDivElement>(SELECTOR_STICKY_FORM);
  var yOffset = window.scrollY;

  // Adjust this value as needed to control when the button becomes sticky
  var scrollThreshold = 800;

  // Check for the sticky form
  if(!stickyForm) return; 

  if (yOffset > scrollThreshold) {
    stickyForm!.style.display = 'block';
  } else {
    stickyForm!.style.display = 'none';
  }
});